module.exports = __webpack_public_path__ + "img/USERAL.2be4becf.svg";